import React, { useState, useEffect } from "react";
import {
  Card,
  Modal,
  Form,
  Button,
  Row,
  Col,
} from "@themesberg/react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showModalEditarProductoAction,
  editarProductosAction,
} from "../../actions/productosActions";
import { getBase64 } from "../../helpers";
import ReactMultiSelect from "@kenshooui/react-multi-select";
import clienteAxios from "../../config/axios";
import Swal from "sweetalert2";

export default (props) => {
  const dispatch = useDispatch();

  const [empleadoPuestos, setEmpleadoPuestos] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [edicion, guardar] = useState({
    id_empleado: null,
    puestos: [],
  });

  useEffect(() => {
    guardar({
      ...edicion,
      ...props,
    });
  }, [props]);

  useEffect(() => {
    if (props.empleado) {
      edicion.id_empleado = props.empleado.id;

      guardar({
        ...edicion,
        id_empleado: props.empleado.id,
      });

      getEmpleadoPuestos();
    }
  }, [props.empleado]);

  useEffect(() => {
    setShowModal(props.showModal);

    if (props.showModal === true) {
      getPuestos();
    }
  }, [props.showModal]);

  const submitForm = (e) => {
    e.preventDefault();
    clienteAxios
      .put("empleados/puestos", {
        id_empleado: edicion.id_empleado,
        id_puestos: edicion.puestos ? edicion.puestos.map((puesto) => puesto.id) : [],
      })
      .then((respuesta) => {
        if (
          respuesta &&
          respuesta.data.data &&
          respuesta.data.success === true
        ) {
          props.onHide();
          setShowModal(false);
          Swal.fire("¡Muy bien!", respuesta.data.message, "success");
        }
      });
  };

  const handleClose = () => {
    props.onHide();
    setShowModal(false);
  };

  const getEmpleadoPuestos = () => {
    clienteAxios
      .get("empleados/puestos/" + edicion.id_empleado)
      .then((respuesta) => {
        if (
          respuesta &&
          respuesta.data.data &&
          respuesta.data.success === true
        ) {
          setEmpleadoPuestos(respuesta.data.data);
          guardar({
            ...edicion,
            puestos: respuesta.data.data.map((empleadoPuesto) => {
              return {
                id: empleadoPuesto.puesto_laboral.id,
                label: empleadoPuesto.puesto_laboral.nombre,
              };
            }),
          });
        }
      });
  };

  const getPuestos= () => {
    clienteAxios.get("puestos-laborales").then((respuesta) => {
      if (respuesta && respuesta.data.data && respuesta.data.success === true) {
        setPuestos(respuesta.data.data);
      }
    });
  };

  const renderPuestos = () => {
    return puestos.map((puesto) => {
      return {
        id: puesto.id,
        label: puesto.nombre,
      };
    });
  };

  const handleChange = (selectedItems) => {
    guardar({
      ...edicion,
      puestos: selectedItems,
    });
  };

  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title className="h6">Puestos</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Form onSubmit={submitForm}>
        <Modal.Body>
          <ReactMultiSelect
            items={renderPuestos()}
            selectedItems={edicion.puestos}
            onChange={handleChange}
            messages={{
              searchPlaceholder: "Buscar...",
              noItemsMessage: "No se encontraron resultados...",
              noneSelectedMessage: "Sin seleccionar",
              selectedMessage: "Seleccionado",
              selectAllMessage: "Seleccionar todo",
              clearAllMessage: "Limpiar todo",
              disabledItemsTooltip: "Solo puedes seleccionar una opción",
            }}
            showSelectedItems={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="text-gray ms-auto"
            onClick={handleClose}
          >
            Cerrar
          </Button>
          <Button type="submit" variant="secondary">
            Actualizar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
